module.exports = function () {
    if ($('.iframe-page__container').length) {
        var iframeHost = $('.iframe-page__container').data('iframeHost');

        var onMessage = function (event) {
            if (event.origin !== iframeHost) {
                return;
            }

            var data = event.data;

            var path = data.func.split('.');

            var resolved;
            if (path.length === 1) {
                resolved = window[path[0]];
            } else {
                resolved = window[path[0]];
                for (var i = 1; i < path.length; i++) {
                    resolved = resolved[path[i]];
                }
            }

            if (typeof (resolved) === "function") {
                resolved.call(null, data.message);
            }
        };

        if (window.addEventListener) {
            window.addEventListener("message", onMessage, false);
        }
        else if (window.attachEvent) {
            window.attachEvent("onmessage", onMessage, false);
        }

        $(window).on('popstate', function () {
            var iframe = $('.iframe-page__container').find('iframe')[0];
            if (window.iframePaths && window.iframePaths.length > 1) {
                iframe.src = window.iframePaths[window.iframePaths.length - 2];
                window.iframePaths.pop();
                window.iframePaths.pop();
            } else {
                iframe.src = iframe.src;
            }
        });
    }
};